
import * as table from './TableData'
import { numberWithCommas } from "../Report_common_function";
import { date_dmy_func, convertOnlyTimefunc, currentDate_dmy, CurrentTime, compareGSTINState, loginUserIsFranchisesRole, IsSweetAndSnacksCompany, GET_ERP_IMG, GET_COMPANY_FROM_URL } from "../../components/Common/CommonFunction";
import { url } from '../../routes';



export const pageBorder = (doc) => {
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.5)
    doc.line(570, 16, 30, 16);//horizontal line (Top)
    doc.line(30, 393, 30, 16);//vertical line (left)
    doc.line(570, 393, 570, 16);//vertical line (Right)
    doc.line(570, 393, 30, 393);//horizontal line (Bottom)   
}

let initial_y = 0

export const qrOffset = (doc, data) => {
    if (!data?.isQR) return 0;
    return doc.internal.getCurrentPageInfo().pageNumber === 1 ? 48 : 0;
};

const isSweetAndSnacksCompany = IsSweetAndSnacksCompany()

export const pageHeder = (doc, data) => {
    const off = qrOffset(doc, data); 
    const isChallan = data?.subPageMode === url.CHALLAN_MASTER_LIST;
    const erpImg = GET_ERP_IMG();
    const companyCode = GET_COMPANY_FROM_URL();

    let storedTheme = null;

    try {
        storedTheme = JSON.parse(
            localStorage.getItem(`${companyCode}_companyTheme`)
        );
    } catch (e) { }

    let logoToUse = null;

    // ✅ CASE 1: No company in URL → show default
    if (!companyCode || companyCode === "Default") {
        logoToUse = erpImg.Logo;
    }
    // ✅ CASE 2: Registered company WITH logo
    else if (storedTheme?.CompanyLogo) {
        logoToUse = erpImg.Logo;
    }
    if (logoToUse) {
        if (!isSweetAndSnacksCompany) {
            doc.addImage(GET_ERP_IMG().Logo, 'PNG', 33, 3, 52, 55, null, 'FAST')
        }
    }
    doc.setFont('Tahoma')
    doc.setFont(undefined, 'bold')
    doc.setFontSize(15)








    if (data?.ReportFormat === "GRN") {
        doc.text('Goods Received Note', 180, 35,)
    } else if (isChallan) {
        doc.text('Challan', 180, 35,)
    } else {
        doc.text('TAX INVOICE', 180, 35,)
    }



    doc.setDrawColor(0, 0, 0);
    doc.line(570, 45 + off, 30, 45 + off) //Full horizontal line Bill by Upper line
    doc.setFontSize(7)
    doc.text('Original For Buyer', 330, 28,)

}

export const reportHeder1 = (doc, data) => {
    initial_y = 0;
    const off = qrOffset(doc, data);
    doc.setFont('Tahoma')
    doc.setFontSize(10)
    doc.setFont(undefined, 'bold')
    doc.text("Billed by", 80, 55 + off)   //bill by 
    doc.text('Billed to', 280, 55 + off)   //billed to
    doc.text('Details of Transport', 440, 55 + off) //Details of Transport
    doc.line(570, 45 + off, 30, 45 + off);//horizontal line  when header on next page bottom line
    doc.line(570, 60 + off, 30, 60 + off);// full horizontal bill by bill to below line 
    doc.line(30, 350, 30, 16);//vertical left 1
    doc.line(570, 350, 570, 16);//vertical left 2



    var BilledByStyle = {

        didDrawCell: (data1) => {

            const rowIdx = data1.row.index;
            const colIdx = data1.column.index;
            if (rowIdx === 0 && colIdx === 0) {
                let x = data1.cursor.x + 2
                let y = data1.cursor.y + 8
                doc.setFontSize(8)
                doc.setFont(undefined, 'bold')
                doc.text('Party: ', x, y)
            };
            if (rowIdx === 1 && colIdx === 0) {

                let x = data1.cursor.x + 2
                let y = data1.cursor.y + 8
                doc.setFontSize(8)
                doc.setFont(undefined, 'bold')
                doc.text('Address: ', x, y)
            };
            if (rowIdx === 2 && colIdx === 0) {

                let x = data1.cursor.x + 2
                let y = data1.cursor.y + 8
                doc.setFontSize(8)
                doc.setFont(undefined, 'bold')
                doc.text('State: ', x, y)
            };
            if (rowIdx === 3 && colIdx === 0) {

                let x = data1.cursor.x + 2
                let y = data1.cursor.y + 8
                doc.setFontSize(8)
                doc.setFont(undefined, 'bold')
                doc.text('GSTIN: ', x, y)
            };
            if (rowIdx === 4 && colIdx === 0) {

                let x = data1.cursor.x + 2
                let y = data1.cursor.y + 8
                doc.setFontSize(8)
                doc.setFont(undefined, 'bold')
                doc.text('FSSAI No: ', x, y)
            };
            if (rowIdx === 5 && colIdx === 0) {

                let x = data1.cursor.x + 2
                let y = data1.cursor.y + 8
                doc.setFontSize(8)
                doc.setFont(undefined, 'bold')
                doc.text('Mobile No: ', x, y)
            };

        },
        didParseCell: (data1) => {
            if (data1.row.cells[0].raw === `            ${data.PartyName}`) {
                data1.row.cells[0].styles.fontStyle = "bold"
            }
        },
        margin: {
            top: 45, left: 30, right: 35,
        },
        showHead: 'always',
        theme: 'plain',
        styles: {
            overflow: 'linebreak',
            fontSize: 8,
            height: 0,
        },
        bodyStyles: {
            columnWidth: 'wrap',
            textColor: "black",
            cellPadding: 1,
            fontSize: 8,
            fontStyle: 'normal',
            lineColor: [0, 0, 0]
        },
        columnStyles: {
            0: {
                valign: "top",
                columnWidth: 190,
                halign: 'left',
            }

        },
        tableLineColor: "black",
        startY: 62 + off,

    };
    var BilledToStyle = {
        didDrawCell: (data1) => {
            const rowIdx = data1.row.index;
            const colIdx = data1.column.index;

            if (colIdx !== 0) return;

            let x = data1.cursor.x + 2;
            let y = data1.cursor.y + 8;

            doc.setFontSize(8);
            doc.setFont(undefined, "bold");

            const hasShippingAddress =
                !!data?.CoustomerShipingAddress?.trim();

            const hasShippingFSSAI =
                !!data?.CoustomerShipingAddressFSSAI?.trim();

            const labels = [
                "Customer: ",
                "Address: ",
            ];

            if (hasShippingAddress) {
                labels.push("Shipping Address: ");
            }

            if (hasShippingFSSAI) {
                labels.push("Shipping FSSAI: ");
            }

            labels.push(
                "State: ",
                "GSTIN: ",
                "FSSAI No: ",
                "Mobile No: "
            );

            if (labels[rowIdx]) {
                doc.text(labels[rowIdx], x, y);
            }
        },
        didParseCell: (data1) => {
            if (data1.row.cells[0].raw === `                   ${data.CustomerName}`) {
                data1.row.cells[0].styles.fontStyle = "bold"
            }
        },
        margin: {
            top: 45, left: 220, right: 35,
        },
        showHead: 'always',
        theme: 'plain',
        styles: {
            overflow: 'linebreak',
            fontSize: 8,
            height: 0,
        },
        bodyStyles: {
            columnWidth: 'wrap',
            textColor: "black",
            cellPadding: 1,
            fontSize: 8,

            fontStyle: 'normal',
            lineColor: [0, 0, 0]
        },
        columnStyles: {
            0: {
                valign: "top",
                columnWidth: 188,
                halign: 'left',
            },
        },
        tableLineColor: "black",
        startY: 62 + off,

    };
    var DetailsOfTransportStyle = {

        didDrawCell: (data1) => {
            const isChallan = data?.subPageMode === url.CHALLAN_MASTER_LIST
            const Description = isChallan ? (data?.OrderDescription || "") : (data?.InvoicesReferences?.[0]?.Description || "");
            const poNo = data?.InvoicesReferences?.[0]?.FullOrderNumber || "";
            const challanNo = data?.InvoicesReferences?.[0]?.FullChallanNumber || "";
            const rowIdx = data1.row.index;
            const colIdx = data1.column.index;
            if (rowIdx === 0 && colIdx === 0) {
                let x = data1.cursor.x + 2
                let y = data1.cursor.y + 8
                doc.setFontSize(8)
                doc.setFont(undefined, 'bold')
                if (!poNo && challanNo) {
                    // doc.text('Challan No: ', x, y)
                } else {
                    doc.text('PO No: ', x, y)
                }
            };
            if (rowIdx === 1 && colIdx === 0) {

                let x = data1.cursor.x + 2
                let y = data1.cursor.y + 8
                doc.setFontSize(8)
                doc.setFont(undefined, 'bold')
                doc.text('Driver Name: ', x, y)
            };
            if (rowIdx === 2 && colIdx === 0) {

                let x = data1.cursor.x + 2
                let y = data1.cursor.y + 8
                doc.setFontSize(8)
                doc.setFont(undefined, 'bold')
                doc.text('Vehicle No: ', x, y)
            };
            if (rowIdx === 3 && colIdx === 0) {

                let x = data1.cursor.x + 2
                let y = data1.cursor.y + 8
                doc.setFontSize(8)
                doc.setFont(undefined, 'bold')
                doc.text('E-way Bill: ', x, y)
            };
            if (rowIdx === 4 && colIdx === 0) {

                let x = data1.cursor.x + 2
                let y = data1.cursor.y + 8
                doc.setFontSize(8)
                doc.setFont(undefined, 'bold')
                doc.text('ACK No:   ', x, y)
            };
            if (rowIdx === 5 && colIdx === 0 && poNo && challanNo) {
                let x = data1.cursor.x + 2
                let y = data1.cursor.y + 9
                doc.setFontSize(8)
                doc.setFont(undefined, 'bold')
                // doc.text('Challan No: ', x, y)
            };
            if (rowIdx === 6 && colIdx === 0 && Description && isChallan) {
                let x = data1.cursor.x + 2
                let y = data1.cursor.y + 9
                doc.setFontSize(8)
                doc.setFont(undefined, 'bold')
                doc.text('Description: ', x, y)
            };

        },

        margin: {
            top: 45, left: 408, right: 35,
        },
        showHead: 'always',
        theme: 'plain',
        headerStyles: { cellPadding: 1, },
        styles: {
            overflow: 'linebreak',
            fontSize: 8,
            height: 0,
        },
        bodyStyles: {
            columnWidth: 'wrap',
            textColor: [30, 30, 30],
            cellPadding: 1,
            fontSize: 8,
            textColor: "black",
            fontStyle: 'normal',
            lineColor: [0, 0, 0]
        },
        columnStyles: {
            0: {
                valign: "top",
                columnWidth: 162,
                halign: 'left',
            },
        },
        tableLineColor: "black",

        startY: 62 + off,
    };

    const priLength = () => {
        let final_y = doc.previousAutoTable.finalY
        if (final_y > initial_y) {
            initial_y = final_y
        }
    }

    if (data.isQR && off) {
        doc.autoTable(table.INR_NO, table.IRNNumberRow(data), {
            margin: { top: 45, left: 408, right: 35 },
            showHead: 'always',
            theme: 'grid',
            styles: { overflow: 'linebreak', fontSize: 7, height: 0 },
            bodyStyles: { textColor: [30, 30, 30], cellPadding: 1, fontSize: 7, fontStyle: 'bold', lineColor: [0, 0, 0] },
            columnStyles: { 0: { valign: 'top', columnWidth: 162, halign: 'left' } },
            tableLineColor: 'black',
            startY: 46,
        });
    }

    doc.autoTable(table.BilledBy, table.BilledByRow(data), BilledByStyle);
    priLength()

    doc.autoTable(table.BilledTo, table.BilledToRow(data), BilledToStyle);
    priLength()

    doc.autoTable(table.DetailsOfTransport, table.DetailsOfTransportRow(data), DetailsOfTransportStyle);
    priLength()
}


export const reportHeder3 = (doc, data) => {
    const isChallan = data?.subPageMode === url.CHALLAN_MASTER_LIST;
    doc.setFont('Tahoma')
    doc.setFontSize(9)
    doc.setDrawColor(0, 0, 0);
    doc.line(570, 30, 408, 30) //horizontal line 1 billby upper
    doc.line(408, 45, 408, 16);//vertical Line header
    // doc.line(570, 44, 408, 44) //horizontal line 1 billby upper

    doc.setFont(undefined, 'bold')



    if (data?.ReportFormat === "GRN") {
        doc.text(`GRN No:   ${data.FullInvoiceNumber}`, 415, 25) //Invoice Id
        var date = date_dmy_func(data.InvoiceDate)
        var time = convertOnlyTimefunc(data.CreatedOn)
        doc.text(`GRN Date: ${date}  ${time}`, 415, 40) //Invoice date
    } else if (isChallan) {
        doc.text(`Challan No:   ${data.FullInvoiceNumber}`, 415, 25) //Invoice Id
        var date = date_dmy_func(data.InvoiceDate)
        var time = convertOnlyTimefunc(data.CreatedOn)
        doc.text(`Challan Date: ${date}`, 415, 40) //Invoice date
    } else {
        doc.text(`Invoice No:   ${data.FullInvoiceNumber}`, 415, 25) //Invoice Id
        var date = date_dmy_func(data.InvoiceDate)
        var time = convertOnlyTimefunc(data.CreatedOn)
        doc.text(`Invoice Date: ${date}  ${time}`, 415, 40) //Invoice date
    }

}


export const reportFooter = (doc, data) => {


    if (data.SettingData.Qr_Image === null) {

    } else {
        doc.addImage(data.SettingData.Qr_Image, 'JPEG', 335, 303, 105, 96, null, 'FAST');
    }


    doc.setDrawColor(0, 0, 0);
    doc.line(570, 294, 30, 294);//horizontal line  (4)


    doc.line(435, 294, 435, 393);//vertical line (3)
    doc.line(340, 294, 340, 393);//vertical line (2)
    let invoiceItemsForTotals;

    if (data.InvoiceItems.some((item) => item.IsMixItem === false && item.MixItemId !== null)) {
        // Mix items present -> exclude their component sub-items to avoid double counting
        invoiceItemsForTotals = data.InvoiceItems.filter(
            (item) => item.IsMixItem === true || item.MixItemId === null
        );
    } else {
        // No mix items -> original behavior, untouched
        invoiceItemsForTotals = data.InvoiceItems;
    }
    const a = invoiceItemsForTotals.map((data) => ({

        CGST: Number(data.CGST),
        SGST: Number(data.SGST),
        BasicAmount: Number(data.BasicAmount),
        Discount: Number(data.DiscountAmount),
        IGST: Number(data.IGST)
    }));
    var totalCGST = 0;
    var totalSGST = 0;
    var TotalBasicAmount = 0;
    var TotalDiscount = 0
    var totalICGST = 0
    a.forEach(arg => {
        totalCGST += arg.CGST;
        totalSGST += arg.SGST;
        TotalBasicAmount += arg.BasicAmount;
        TotalDiscount += arg.Discount;
        totalICGST += arg.IGST

    });
    const TotalGST = totalCGST + totalSGST;
    doc.setFontSize(8)


    const isIGST = compareGSTINState(data.CustomerGSTIN, data.PartyGSTIN, data?.IsSEZ)

    if (isIGST || data.isAmerica) {

        doc.text(`Total Basic:`, 440, 310,)
        doc.text(`${TotalBasicAmount.toFixed(2)}`, 567, 310, 'right')

        doc.text(`Total Disc:`, 440, 320,)
        doc.text(` ${TotalDiscount.toFixed(2)}`, 567, 320, 'right')

        doc.text(`Total IGST:`, 440, 330)
        doc.text(`${totalICGST.toFixed(2)}`, 567, 330, 'right')

        doc.text(`Total GST:`, 440, 340,)
        doc.text(` ${totalICGST.toFixed(2)}`, 567, 340, 'right')


    } else {
        doc.text(`Total Basic:`, 440, 300,)
        doc.text(`${numberWithCommas(TotalBasicAmount.toFixed(2))}`, 567, 300, 'right')

        doc.text(`Total Disc:`, 440, 310,)
        doc.text(`${numberWithCommas(TotalDiscount.toFixed(2))}`, 567, 310, 'right')

        doc.text(`Total CGST:`, 440, 320)
        doc.text(`${numberWithCommas(totalCGST.toFixed(2))}`, 567, 320, 'right')

        doc.text(`Total SGST:`, 440, 330,)
        doc.text(`${numberWithCommas(totalSGST.toFixed(2))}`, 567, 330, 'right')

        doc.text(`Total GST:`, 440, 340,)
        doc.text(` ${numberWithCommas(TotalGST.toFixed(2))}`, 567, 340, 'right')

    }

    if (!data.isAmerica) {
        const advanceAmount = isNaN(Number(data?.AdvanceAmount)) ? 0 : Number(data?.AdvanceAmount);

        doc.text(`Round Off:`, 440, 350,)
        doc.text(` ${Number(data.RoundOffAmount || 0).toFixed(2)}`, 567, 350, 'right')

        doc.text(`TCS Amount:`, 440, 360,)
        doc.text(` ${numberWithCommas(Number(data.TCSAmount || 0).toFixed(2))}`, 567, 360, 'right')
        if (loginUserIsFranchisesRole()) {
            doc.text(`Advance Amount:`, 440, 370,)
            doc.text(` ${numberWithCommas(Number(advanceAmount).toFixed(2))}`, 567, 370, 'right')

            doc.text(`Net Payable:`, 440, 380,)
            doc.text(` ${numberWithCommas((Number(data.GrandTotal) - (Number(advanceAmount))).toFixed(2))}`, 567, 380, 'right')
        }
    }





    doc.setFont(undefined, 'Normal')
    doc.setFontSize(10)
    doc.setFont(undefined, 'bold')
    doc.text(`Total Amount :`, 439, 390,)
    const Total = numberWithCommas(Number(data.GrandTotal).toFixed(2))
    doc.text(`${Total}`, 567, 390, 'right')

    doc.setFont(undefined, 'bold')

    let DetailsOfCurrencyStyle = {

        didDrawCell: (data1) => {
            const rowIdx = data1.row.index;
            const colIdx = data1.column.index;
            if (rowIdx === 0 && colIdx === 0) {
                let x = data1.cursor.x + 2
                let y = data1.cursor.y + 8
                doc.setFontSize(8)
                doc.setFont(undefined, 'bold')
                if (data.isAmerica) {
                    doc.text('Dollars: ', x, y)
                } else {
                    doc.text('Rupees: ', x, y)
                }
            }
        },

        margin: {
            top: 0, left: 30,
        },
        showHead: 'always',
        theme: 'grid',
        styles: {
            overflow: 'linebreak',
            fontSize: 8,
            height: 0,
        },
        bodyStyles: {
            columnWidth: 'wrap',
            textColor: "black",
            cellPadding: 1,
            fontSize: 8,
            lineColor: "black"
        },
        columnStyles: {
            0: {
                valign: "top",
                columnWidth: 310,
                halign: 'left',
            }

        },
        tableLineColor: "black",
        startY: 294,

    };



    doc.autoTable(table.Currencycolumn, table.CurrencyRow(data), DetailsOfCurrencyStyle,);


    let DetailsOfBankStyle = {
        didParseCell: (data1) => {
            if (data?.BankData?.length > 0) {
                let BankData = data.BankData[0]
                if (data1.row.cells[0].raw === `Bank Name :${BankData.BankName}`) {
                    data1.row.cells[0].colSpan = 3
                }
            }
        },


        margin: {
            top: 0, left: 30, right: 35,
        },
        showHead: 'always',
        theme: (data?.BankData?.length > 0) ? 'grid' : 'plain',
        headerStyles: { cellPadding: 1, },
        styles: {
            overflow: 'linebreak',
            fontSize: 8.5,
            height: 0,
        },
        bodyStyles: {
            columnWidth: 'wrap',
            textColor: "black",
            cellPadding: 2,
            fontSize: 7,
            lineColor: "black"
        },
        columnStyles: {
            0: {
                valign: "top",
                columnWidth: (data?.BankData?.length > 0) ? 90 : 30,
                halign: 'left',
            },
            1: {
                valign: "top",
                columnWidth: (data?.BankData?.length > 0) ? 90 : 300,
                halign: 'left',


            },
            2: {
                valign: "top",
                columnWidth: 130,
                halign: 'left',
            },

        },
        tableLineColor: "black",

        startY: doc.previousAutoTable.finalY,

    };
    doc.autoTable(table.Bankcolumn, table.BankRow(data, doc), DetailsOfBankStyle,);

    doc.setFontSize(8)
    doc.setFont(undefined, 'Normal')

    doc.text(`I/we hearby certify that food/foods mentioned in this invoice is/are warranted to be
 of the nature and quantity which it/these purports to be `, 34, doc.previousAutoTable.finalY + (9),)
    doc.line(340, doc.previousAutoTable.finalY + (21), 30, doc.previousAutoTable.finalY + (21)); //horizontal line (1)


    //  GET CHALLAN DATA
    const challanNumbers = (data?.InvoicesReferences || [])
        .map(item => item?.FullChallanNumber)
        .filter(val => val)
        .join(", ");

    //  ONLY INVOICE
    if (data?.subPageMode !== url.CHALLAN_MASTER_LIST && data?.ReportFormat !== "GRN") {

        const baseY = doc.previousAutoTable.finalY;

        doc.setFontSize(7);
        doc.setFont(undefined, 'bold');

        // TEXT
        const challanText = `Challan No: ${challanNumbers || ""}`;
        // A5 la width kami aslyamule wrap
        const wrappedChallan = doc.splitTextToSize(challanText, 300);
        doc.text(
            wrappedChallan,
            32,
            baseY + 31
        );

        // dynamic line position
        const lineY = Math.min(baseY + 31 + (wrappedChallan.length * 7), 380);

        doc.line(340, lineY, 30, lineY);
    }

    doc.text(`Signature `, 280, 387,)
    doc.text(`Prepared by :${data.PartyName} `, 35, 387,)
}



export const tableBody = (doc, data) => {

    var options = {

        didParseCell: (data1) => {

            if (data1.row.cells[9].raw === "isaddition") {
                data1.row.cells[1].colSpan = 5
                data1.row.cells[8].colSpan = 2
                data1.row.cells[10].colSpan = 2

                data1.row.cells[1].styles.halign = "right"    // Alignment for  cgst and Total in spanrow

                data1.row.cells[1].styles.fontSize = 7
                data1.row.cells[8].styles.fontSize = 7
                data1.row.cells[7].styles.fontSize = 7
                data1.row.cells[10].styles.fontSize = 7
                data1.row.cells[12].styles.fontSize = 7

                data1.row.cells[1].styles.fontStyle = "bold"
                data1.row.cells[8].styles.fontStyle = "bold"
                data1.row.cells[7].styles.fontStyle = "bold"
                data1.row.cells[10].styles.fontStyle = "bold"
                data1.row.cells[12].styles.fontStyle = "bold"
            }

            if (data1.row.cells[1].raw === "HSN Item Name") {
                let TotalBox = 0;
                const unit = isSweetAndSnacksCompany ? "Tray" : "Box"

                data.InvoiceItems.forEach((element, key) => {
                    if (element.PrimaryUnitName === unit) {
                        TotalBox = Number(TotalBox) + Number(element.Quantity)
                    }
                })
                if (TotalBox === 0) {
                    data1.row.cells[1].text[0] = ` HSN Item Name (${data.TotalItemlength})`
                } else {
                    data1.row.cells[1].text[0] = ` HSN Item Name (${data.TotalItemlength})  (${TotalBox} ${unit})`
                }
                data1.row.cells[8].colSpan = 2
                data1.row.cells[10].colSpan = 2
            }
            if (data1.row.cells[1].raw === "Batch") {
                data1.row.cells[0].colSpan = 13

            }
            const srNo = data1.row.cells[0]?.raw;   // SrNo column
            const itemName = data1.row.cells[1]?.raw;

            if (data1.row.section === 'body' && typeof itemName === "string") {
                const isParentWithMix = !!data1.row.raw.isParentWithMix;
                const childCount = Number(data1.row.raw._childCount || 0);

                // If this is a child row, clear SN cell text (should already be ""), and style child name
                if (data1.row.raw._isChild) {

                    if (data1.row.cells[0]) {
                        data1.row.cells[0].colSpan = 13; // batch row sarkha full row span
                        data1.row.cells[0].styles.fontSize = 7;
                        data1.row.cells[0].styles.textColor = [40, 40, 40];
                        data1.row.cells[0].styles.fontStyle = "bold";
                    }
                }

                // existing styling for parent/normal item names (keeping original)
                if (srNo !== "" && isParentWithMix) {
                    // Parent with mix items → Always bold, dark black for name column
                    data1.row.cells[1].styles.fontStyle = "bold";
                    data1.row.cells[1].styles.textColor = [0, 0, 0];
                    data1.row.cells[1].styles.fontSize = 7;
                } else if (srNo !== "" && !isParentWithMix) {
                    data1.row.cells[1].styles.fontStyle = "normal";
                    data1.row.cells[1].styles.textColor = [0, 0, 0];
                    data1.row.cells[1].styles.fontSize = 7;
                }
            }

        },
        didDrawCell: (data1) => {

            const rowIdx = data1.row.index;
            const colIdx = data1.column.index;
            if (rowIdx === 0 && colIdx === 8) {
                if (data1.row.cells[8].raw === "          CGST           %        Amount") {

                    const cellWidth = data1.cell.width;
                    const cellHeight = data1.cell.height;
                    const startX = data1.cell.x;
                    const startY = data1.cell.y + cellHeight / 2;
                    const endX = startX + cellWidth;
                    const endY = startY;

                    const startXVertical = data1.cell.x + cellWidth / 2; // X-coordinate at the middle of the cell
                    const startY1vertical = data1.cell.y + 9;
                    const endYvertical = startY + cellHeight;

                    doc.line(startXVertical - 5, startY1vertical, startXVertical - 5, endYvertical); // Draw a vertical line
                    doc.line(startX, startY, endX, endY);
                }
            }
            if (rowIdx === 0 && colIdx === 10) {
                if (data1.row.cells[10].raw === "          SGST           %        Amount") {

                    const cellWidth = data1.cell.width;
                    const cellHeight = data1.cell.height;
                    const startX = data1.cell.x;
                    const startY = data1.cell.y + cellHeight / 2;
                    const endX = startX + cellWidth;
                    const endY = startY;

                    const startXVertical = data1.cell.x + cellWidth / 2; // X-coordinate at the middle of the cell
                    const startY1vertical = data1.cell.y + 9;
                    const endYvertical = startY + cellHeight;

                    doc.line(startXVertical - 5, startY1vertical, startXVertical - 5, endYvertical); // Draw a vertical line
                    doc.line(startX, startY, endX, endY);
                }
            }

        },
        margin: {
            left: 30, right: 25, top: 56
        },
        theme: 'grid',
        headerStyles: {
            cellPadding: 1,
            lineWidth: 0.3,
            valign: 'top',
            fontStyle: 'bold',
            halign: 'center',    //'center' or 'right'
            fillColor: "white",
            textColor: [0, 0, 0], //Black     
            fontSize: 7,
            rowHeight: 10,
            lineColor: [0, 0, 0]
        },
        bodyStyles: {
            textColor: [30, 30, 30],
            cellPadding: 3,
            fontSize: 7,
            columnWidth: 'wrap',
            lineColor: [0, 0, 0],
        },
        columnStyles: {
            0: {
                valign: "top",
                fontSize: 6,
                columnWidth: 15,
            },
            1: {
                valign: "top",
                columnWidth: 135,
            },
            2: {
                columnWidth: 52,
                halign: 'right',
            },
            3: {
                columnWidth: 28,
                halign: 'right',
            },
            4: {
                columnWidth: 33,
                halign: 'right',
            },
            5: {
                columnWidth: 35,
                halign: 'right',
            },
            6: {
                columnWidth: 35,
                halign: 'right',
            },

            7: {
                columnWidth: 45,
                halign: 'right',
            },
            8: {
                columnWidth: 24,
                halign: 'right',
            },
            9: {
                columnWidth: 34,
                halign: 'right',
            },
            10: {
                columnWidth: 24,
                halign: 'right',
            },
            11: {
                columnWidth: 34,
                halign: 'right',

            },
            12: {
                columnWidth: 46,
                halign: 'right',
            },

        },
        tableLineColor: "black",
        startY: initial_y,

    };
    doc.setLineWidth(0.5);
    ////  lines when report  header line when table cordinates
    doc.line(408, initial_y, 408, 16);//vertical right 1
    doc.line(220, initial_y, 220, 45 + qrOffset(doc, data));//vertical line between billby billto
    doc.line(570, initial_y, 30, initial_y) //horizontal line 1 billby upper



    doc.autoTable(table.columnsWithCGST_SGST, table.RowsWithCGST_SGST(data), options,);

    const Buttom_Hidden_Table_To_Avoid_FooterOverlap = {
        margin: {
            left: 30, right: 30, bottom: 110
        },
    };

    doc.autoTable(Buttom_Hidden_Table_To_Avoid_FooterOverlap);
}


export const tableBodyWithIGST = (doc, data) => {
    var options = {

        didParseCell: (data1) => {

            if (data1.row.cells[9].raw === "isaddition") {
                data1.row.cells[1].colSpan = 5
                // data1.row.cells[3].colSpan = 5
                data1.row.cells[8].colSpan = 2
                // data1.row.cells[10].colSpan = 2

                data1.row.cells[1].styles.fontSize = 7
                data1.row.cells[1].styles.halign = "right"    // Alignment for  cgst and Total in spanrow

                data1.row.cells[8].styles.fontSize = 7
                data1.row.cells[7].styles.fontSize = 7
                data1.row.cells[10].styles.fontSize = 7
                // data1.row.cells[12].styles.fontSize = 7
                data1.row.cells[1].styles.fontStyle = "bold"
                data1.row.cells[8].styles.fontStyle = "bold"
                data1.row.cells[7].styles.fontStyle = "bold"
                data1.row.cells[10].styles.fontStyle = "bold"
                // data1.row.cells[12].styles.fontStyle = "bold"
            }

            if (data1.row.cells[1].raw === "HSN Item Name") {

                let TotalBox = 0;
                const unit = isSweetAndSnacksCompany ? "Tray" : "Box"

                data.InvoiceItems.forEach((element, key) => {
                    if (element.PrimaryUnitName === unit) {
                        TotalBox = Number(TotalBox) + Number(element.Quantity)
                    }
                })
                if (TotalBox === 0) {
                    data1.row.cells[1].text[0] = ` HSN Item Name (${data.TotalItemlength})`
                } else {
                    data1.row.cells[1].text[0] = ` HSN Item Name (${data.TotalItemlength})  (${TotalBox} ${unit})`
                }


                data1.row.cells[8].colSpan = 2

            }

            if (data1.row.cells[1].raw === "Batch") {
                data1.row.cells[0].colSpan = 12

            }
            const srNo = data1.row.cells[0]?.raw;   // SrNo column
            const itemName = data1.row.cells[1]?.raw;

            if (data1.row.section === 'body' && typeof itemName === "string") {
                const isParentWithMix = !!data1.row.raw.isParentWithMix;
                const childCount = Number(data1.row.raw._childCount || 0);

                // If this is a child row, clear SN cell text (should already be ""), and style child name
                if (data1.row.raw._isChild) {

                    if (data1.row.cells[0]) {
                        data1.row.cells[0].colSpan = 13; // batch row sarkha full row span
                        data1.row.cells[0].styles.fontSize = 7;
                        data1.row.cells[0].styles.textColor = [40, 40, 40];
                        data1.row.cells[0].styles.fontStyle = "bold";
                    }
                }

                // existing styling for parent/normal item names (keeping original)
                if (srNo !== "" && isParentWithMix) {
                    // Parent with mix items → Always bold, dark black for name column
                    data1.row.cells[1].styles.fontStyle = "bold";
                    data1.row.cells[1].styles.textColor = [0, 0, 0];
                    data1.row.cells[1].styles.fontSize = 7;
                } else if (srNo !== "" && !isParentWithMix) {
                    data1.row.cells[1].styles.fontStyle = "normal";
                    data1.row.cells[1].styles.textColor = [0, 0, 0];
                    data1.row.cells[1].styles.fontSize = 7;
                }
            }
        },

        didDrawCell: (data1) => {

            const rowIdx = data1.row.index;
            const colIdx = data1.column.index;
            if (rowIdx === 0 && colIdx === 8) {
                if (data1.row.cells[8].raw === "          IGST           %         Amount") {

                    const cellWidth = data1.cell.width;
                    const cellHeight = data1.cell.height;
                    const startX = data1.cell.x;
                    const startY = data1.cell.y + cellHeight / 2;
                    const endX = startX + cellWidth;
                    const endY = startY;

                    const startXVertical = data1.cell.x + cellWidth / 2; // X-coordinate at the middle of the cell
                    const startY1vertical = data1.cell.y + 9;
                    const endYvertical = startY + cellHeight;

                    doc.line(startXVertical - 4, startY1vertical, startXVertical - 4, endYvertical); // Draw a vertical line
                    doc.line(startX, startY, endX, endY);
                }
            }

        },

        margin: {
            left: 30, right: 25, top: 55
        },
        theme: 'grid',
        headerStyles: {
            cellPadding: 1,
            lineWidth: 0.3,
            valign: 'top',
            fontStyle: 'bold',
            halign: 'center',    //'center' or 'right'
            fillColor: "white",
            textColor: [0, 0, 0], //Black     
            fontSize: 7,
            rowHeight: 10,
            lineColor: [0, 0, 0]
        },
        bodyStyles: {
            textColor: [30, 30, 30],
            cellPadding: 3,
            fontSize: 7,
            columnWidth: 'wrap',
            lineColor: [0, 0, 0],
        },
        columnStyles: {
            0: {
                valign: "top",
                fontSize: 6,
                columnWidth: 15,
            },
            1: {
                valign: "top",
                columnWidth: 175,
            },
            2: {
                columnWidth: 50,
                halign: 'right',
            },
            3: {
                columnWidth: 28,
                halign: 'right',
            },
            4: {
                columnWidth: 33,
                halign: 'right',
            },
            5: {
                columnWidth: 35,
                halign: 'right',
            },
            6: {
                columnWidth: 42,
                halign: 'right',
            },

            7: {
                columnWidth: 50,
                halign: 'right',
            },
            8: {
                columnWidth: 26,
                halign: 'right',
            },
            9: {
                columnWidth: 34,
                halign: 'right',

            },
            10: {
                columnWidth: 52,
                halign: 'right',
            },

        },
        tableLineColor: "black",
        startY: initial_y,
    };
    doc.setLineWidth(0.5)
    doc.line(408, initial_y, 408, 16);//vertical right 1
    doc.line(220, initial_y, 220, 45 + qrOffset(doc, data));//vertical line between billby billto
    doc.line(570, initial_y, 30, initial_y) //horizontal line 1 billby upper
    doc.autoTable(table.columnsWithIGST, table.RowsWithIGST(data), options,);
    const Buttom_Hidden_Table_To_Avoid_FooterOverlap = {
        margin: {
            left: 30, right: 30, bottom: 110
        },
    };

    doc.autoTable(Buttom_Hidden_Table_To_Avoid_FooterOverlap);
}



export const tableBodyWith_CGST_SGST_forSweetAndSnacks = (doc, data) => {
    var options = {
        didParseCell: (data1) => {
            if (data1.row.cells[6].raw === "isaddition") {
                data1.row.cells[1].colSpan = 4
                // data1.row.cells[3].colSpan = 5
                data1.row.cells[5].colSpan = 2
                data1.row.cells[7].colSpan = 2

                data1.row.cells[1].styles.fontSize = 7
                data1.row.cells[1].styles.halign = "right"    // Alignment for  cgst and Total in spanrow

                data1.row.cells[8].styles.fontSize = 7
                data1.row.cells[7].styles.fontSize = 7
                data1.row.cells[9].styles.fontSize = 7
                data1.row.cells[9].styles.fontSize = 7
                data1.row.cells[1].styles.fontStyle = "bold"
                data1.row.cells[8].styles.fontStyle = "bold"
                data1.row.cells[7].styles.fontStyle = "bold"
                data1.row.cells[9].styles.fontStyle = "bold"
                data1.row.cells[9].styles.fontStyle = "bold"
            }


            if (data1.row.cells[1].raw === "HSN Item Name") {

                let TotalBox = 0;
                const unit = isSweetAndSnacksCompany ? "Tray" : "Box"
                data.InvoiceItems.forEach((element, key) => {
                    if (element.PrimaryUnitName === unit) {
                        TotalBox = Number(TotalBox) + Number(element.Quantity)
                    }
                })
                if (TotalBox === 0) {
                    data1.row.cells[1].text[0] = ` HSN Item Name (${data.TotalItemlength})`
                } else {
                    data1.row.cells[1].text[0] = ` HSN Item Name (${data.TotalItemlength})  (${TotalBox} ${unit})`
                }

                data1.row.cells[5].colSpan = 2
                data1.row.cells[7].colSpan = 2
            }
            if (data1.row.cells[1].raw === "Batch") {
                data1.row.cells[0].colSpan = 9

            }

            //  set rowSpan on first column (SN) when parent has children ---
            const srNo = data1.row.cells[0]?.raw;   // SrNo column
            const itemName = data1.row.cells[1]?.raw;

            if (data1.row.section === 'body' && typeof itemName === "string") {
                const isParentWithMix = !!data1.row.raw.isParentWithMix;
                const childCount = Number(data1.row.raw._childCount || 0);

                // If this is a child row, clear SN cell text (should already be ""), and style child name
                if (data1.row.raw._isChild) {

                    if (data1.row.cells[0]) {
                        data1.row.cells[0].colSpan = 13; // batch row sarkha full row span
                        data1.row.cells[0].styles.fontSize = 7;
                        data1.row.cells[0].styles.textColor = [40, 40, 40];
                        data1.row.cells[0].styles.fontStyle = "bold";
                    }
                }

                // existing styling for parent/normal item names (keeping original)
                if (srNo !== "" && isParentWithMix) {
                    // Parent with mix items → Always bold, dark black for name column
                    data1.row.cells[1].styles.fontStyle = "bold";
                    data1.row.cells[1].styles.textColor = [0, 0, 0];
                    data1.row.cells[1].styles.fontSize = 7;
                } else if (srNo !== "" && !isParentWithMix) {
                    data1.row.cells[1].styles.fontStyle = "normal";
                    data1.row.cells[1].styles.textColor = [0, 0, 0];
                    data1.row.cells[1].styles.fontSize = 7;
                }
            }


        },

        didDrawCell: (data1) => {
            const rowIdx = data1.row.index;
            const colIdx = data1.column.index;
            if (rowIdx === 0 && colIdx === 5) {
                if (data1.row.cells[5].raw === "          CGST           %        Amount") {

                    const cellWidth = data1.cell.width;
                    const cellHeight = data1.cell.height;
                    const startX = data1.cell.x;
                    const startY = data1.cell.y + cellHeight / 2;
                    const endX = startX + cellWidth;
                    const endY = startY;

                    const startXVertical = data1.cell.x + cellWidth / 2;  // X-coordinate at the middle of the cell
                    const startY1vertical = data1.cell.y + 9;
                    const endYvertical = startY + cellHeight;

                    doc.line(startXVertical - 5, startY1vertical + 1, startXVertical - 5, endYvertical + 1);  // Draw a vertical line
                    doc.line(startX, startY, endX, endY);
                }
            }
            if (rowIdx === 0 && colIdx === 7) {
                if (data1.row.cells[7].raw === "          SGST           %        Amount") {

                    const cellWidth = data1.cell.width;
                    const cellHeight = data1.cell.height;
                    const startX = data1.cell.x;
                    const startY = data1.cell.y + cellHeight / 2;
                    const endX = startX + cellWidth;
                    const endY = startY;

                    const startXVertical = data1.cell.x + cellWidth / 2;  // X-coordinate at the middle of the cell
                    const startY1vertical = data1.cell.y + 9;
                    const endYvertical = startY + cellHeight;

                    doc.line(startXVertical - 5, startY1vertical + 1, startXVertical - 5, endYvertical + 1); // Draw a vertical line
                    doc.line(startX, startY, endX, endY);
                }
            }

        },
        margin: {
            left: 30, right: 25, top: 63,
        },
        theme: 'grid',
        headerStyles: {
            cellPadding: 2,
            lineWidth: 0.3,
            valign: 'top',
            fontStyle: 'bold',
            halign: 'center',    //'center' or 'right'
            fillColor: "white",
            textColor: "black", //Black     
            fontSize: 7,
            rowHeight: 10,
            lineColor: "black"
        },
        bodyStyles: {
            textColor: [30, 30, 30],
            cellPadding: 3,
            fontSize: 7,
            columnWidth: 'wrap',
            lineColor: [0, 0, 0],
        },
        columnStyles: {
            0: {
                valign: "top",
                fontSize: 6,
                columnWidth: 15,
            },
            1: {
                valign: "top",
                columnWidth: 170,
            },
            2: {
                columnWidth: 70,
                halign: 'right',
            },
            3: {
                columnWidth: 50,
                halign: 'right',
            },
            4: {
                columnWidth: 50,
                halign: 'right',
            },
            5: {
                columnWidth: 24,
                halign: 'right',
            },
            6: {
                columnWidth: 34,
                halign: 'right',
            },
            7: {
                columnWidth: 24,
                halign: 'right',
            },
            8: {
                columnWidth: 34,
                halign: 'right',
            },
            9: {
                columnWidth: 69,
                halign: 'right',
            },

        },
        tableLineColor: "black",
        startY: initial_y,
    };

    doc.line(408, data.isQR ? initial_y : initial_y, 408, 16);//vertical line header section billby 
    doc.line(220, data.isQR ? initial_y : initial_y, 220, data.isQR ? 103 : 63);//vertical  line header section billto


    const indicesToRemove = [3, 5, 6]; // the column indices to remove

    const Rows = table.RowsWithCGST_SGST(data).map(row =>
        row.filter((_, index) => !indicesToRemove.includes(index))
    );


    const columns = table.columnsWithCGST_SGST.filter((_, index) => !indicesToRemove.includes(index))


    doc.autoTable(columns, Rows, options,);
    const optionsTable4 = {
        margin: {
            left: 30, right: 30, bottom: 140
        },
    };
    doc.autoTable(optionsTable4);

}

export const tableBodyWith_IGST_forSweetAndSnacks = (doc, data) => {
    var options = {

        didParseCell: (data1) => {

            if (data1.row.cells[6].raw === "isaddition") {
                data1.row.cells[1].colSpan = 4
                // data1.row.cells[3].colSpan = 5
                data1.row.cells[5].colSpan = 2
                // data1.row.cells[10].colSpan = 2

                data1.row.cells[1].styles.fontSize = 7
                data1.row.cells[1].styles.halign = "right"    // Alignment for  cgst and Total in spanrow

                data1.row.cells[5].styles.fontSize = 7
                data1.row.cells[7].styles.fontSize = 7

                // data1.row.cells[12].styles.fontSize = 7
                data1.row.cells[1].styles.fontStyle = "bold"
                data1.row.cells[5].styles.fontStyle = "bold"
                data1.row.cells[7].styles.fontStyle = "bold"

                // data1.row.cells[12].styles.fontStyle = "bold"
            }

            if (data1.row.cells[1].raw === "HSN Item Name") {
                let TotalBox = 0;
                const unit = isSweetAndSnacksCompany ? "Tray" : "Box"

                data.InvoiceItems.forEach((element, key) => {
                    if (element.PrimaryUnitName === unit) {
                        TotalBox = Number(TotalBox) + Number(element.Quantity)
                    }
                })

                data1.row.cells[1].text[0] = ` HSN Item Name (${data.TotalItemlength})  (${TotalBox} ${unit})`
                data1.row.cells[5].colSpan = 2
            }

            if (data1.row.cells[1].raw === "Batch") {
                data1.row.cells[0].colSpan = 7

            }
        },


        didDrawCell: (data1) => {
            const rowIdx = data1.row.index;
            const colIdx = data1.column.index;
            if (rowIdx === 0 && colIdx === 5) {
                if (data1.row.cells[5].raw === "          IGST           %        Amount") {

                    const cellWidth = data1.cell.width;
                    const cellHeight = data1.cell.height;
                    const startX = data1.cell.x;
                    const startY = data1.cell.y + cellHeight / 2;
                    const endX = startX + cellWidth;
                    const endY = startY;

                    const startXVertical = data1.cell.x + cellWidth / 2;  // X-coordinate at the middle of the cell
                    const startY1vertical = data1.cell.y + 9;
                    const endYvertical = startY + cellHeight;

                    doc.line(startXVertical - 3, startY1vertical, startXVertical - 3, endYvertical);  // Draw a vertical line
                    doc.line(startX, startY, endX, endY);
                }
            }
        },


        margin: {
            left: 30, right: 25, top: 55
        },
        theme: 'grid',
        headerStyles: {
            cellPadding: 1,
            lineWidth: 0.3,
            valign: 'top',
            fontStyle: 'bold',
            halign: 'center',    //'center' or 'right'
            fillColor: "white",
            textColor: [0, 0, 0], //Black     
            fontSize: 7,
            rowHeight: 10,
            lineColor: [0, 0, 0]
        },
        bodyStyles: {
            textColor: [30, 30, 30],
            cellPadding: 3,
            fontSize: 7,
            columnWidth: 'wrap',
            lineColor: [0, 0, 0],
        },
        columnStyles: {
            0: {
                valign: "top",
                fontSize: 6,
                columnWidth: 15,
            },
            1: {
                valign: "top",
                columnWidth: 175,
            },
            2: {
                columnWidth: 80,
                halign: 'right',
            },
            3: {
                columnWidth: 48,
                halign: 'right',
            },
            4: {
                columnWidth: 60,
                halign: 'right',
            },
            5: {
                columnWidth: 28,
                halign: 'right',
            },
            6: {
                columnWidth: 34,
                halign: 'right',
            },

            7: {
                columnWidth: 100,
                halign: 'right',
            },


        },
        tableLineColor: "black",
        startY: initial_y,
    };
    doc.line(408, data.isQR ? initial_y : initial_y, 408, 16);//vertical line header section billby 
    doc.line(220, data.isQR ? initial_y : initial_y, 220, data.isQR ? 103 : 63);//vertical  line header section billto

    // doc.autoTable(table.columnsWithIGST, table.RowsWithIGST(data), options,);
    const indicesToRemove = [3, 5, 6]; // the column indices to remove

    const Rows = table.RowsWithIGST(data).map(row =>
        row.filter((_, index) => !indicesToRemove.includes(index))
    );
    const columns = table.columnsWithIGST.filter((_, index) => !indicesToRemove.includes(index))
    doc.autoTable(columns, Rows, options,);


    const optionsTable4 = {
        margin: {
            left: 30, right: 30, bottom: 110
        },
    };

    doc.autoTable(optionsTable4);
}


export const tableBodyForAmericanInvoice = (doc, data) => {

    var options = {

        didParseCell: (data1) => {

            if (data1.row.cells[8].raw === "isaddition") {
                data1.row.cells[1].colSpan = 5
                // data1.row.cells[3].colSpan = 5
                data1.row.cells[7].colSpan = 2
                // data1.row.cells[10].colSpan = 2

                data1.row.cells[1].styles.fontSize = 7
                data1.row.cells[1].styles.halign = "right"    // Alignment for  cgst and Total in spanrow

                data1.row.cells[7].styles.fontSize = 7
                data1.row.cells[6].styles.fontSize = 7
                data1.row.cells[9].styles.fontSize = 7
                // data1.row.cells[12].styles.fontSize = 7
                data1.row.cells[1].styles.fontStyle = "bold"
                data1.row.cells[7].styles.fontStyle = "bold"
                data1.row.cells[6].styles.fontStyle = "bold"
                data1.row.cells[9].styles.fontStyle = "bold"
                // data1.row.cells[12].styles.fontStyle = "bold"
            }

            if (data1.row.cells[1].raw === "HSN Item Name") {

                let TotalBox = 0;
                const unit = isSweetAndSnacksCompany ? "Tray" : "Box"

                data.InvoiceItems.forEach((element, key) => {
                    if (element.PrimaryUnitName === unit) {
                        TotalBox = Number(TotalBox) + Number(element.Quantity)
                    }
                })
                if (TotalBox === 0) {
                    data1.row.cells[1].text[0] = ` HSN Item Name (${data.TotalItemlength})`
                } else {
                    data1.row.cells[1].text[0] = ` HSN Item Name (${data.TotalItemlength})  (${TotalBox} ${unit})`
                }


                data1.row.cells[7].colSpan = 2

            }

            if (data1.row.cells[1].raw === "Batch") {
                data1.row.cells[0].colSpan = 12

            }
        },

        didDrawCell: (data1) => {

            const rowIdx = data1.row.index;
            const colIdx = data1.column.index;
            if (rowIdx === 0 && colIdx === 7) {
                if (data1.row.cells[7].raw === "          IGST           %         Amount") {

                    const cellWidth = data1.cell.width;
                    const cellHeight = data1.cell.height;
                    const startX = data1.cell.x;
                    const startY = data1.cell.y + cellHeight / 2;
                    const endX = startX + cellWidth;
                    const endY = startY;

                    const startXVertical = data1.cell.x + cellWidth / 2; // X-coordinate at the middle of the cell
                    const startY1vertical = data1.cell.y + 9;
                    const endYvertical = startY + cellHeight;

                    doc.line(startXVertical - 4, startY1vertical, startXVertical - 4, endYvertical); // Draw a vertical line
                    doc.line(startX, startY, endX, endY);
                }
            }

        },

        margin: {
            left: 30, right: 25, top: 55
        },
        theme: 'grid',
        headerStyles: {
            cellPadding: 1,
            lineWidth: 0.3,
            valign: 'top',
            fontStyle: 'bold',
            halign: 'center',    //'center' or 'right'
            fillColor: "white",
            textColor: [0, 0, 0], //Black     
            fontSize: 7,
            rowHeight: 10,
            lineColor: [0, 0, 0]
        },
        bodyStyles: {
            textColor: [30, 30, 30],
            cellPadding: 3,
            fontSize: 7,
            columnWidth: 'wrap',
            lineColor: [0, 0, 0],
        },
        columnStyles: {
            0: {
                valign: "top",
                fontSize: 6,
                columnWidth: 15,
            },
            1: {
                valign: "top",
                columnWidth: 175,
            },
            2: {
                columnWidth: 50,
                halign: 'right',
            },

            3: {
                columnWidth: 33,
                halign: 'right',
            },
            4: {
                columnWidth: 35,
                halign: 'right',
            },
            5: {
                columnWidth: 42,
                halign: 'right',
            },

            6: {
                columnWidth: 50,
                halign: 'right',
            },
            7: {
                columnWidth: 26,
                halign: 'right',
            },
            8: {
                columnWidth: 34,
                halign: 'right',

            },
            9: {
                columnWidth: 80,
                halign: 'right',
            },

        },
        tableLineColor: "black",
        startY: initial_y,
    };
    doc.setLineWidth(0.5)
    doc.line(408, initial_y, 408, 16);//vertical right 1
    doc.line(220, initial_y, 220, 45 + qrOffset(doc, data));//vertical line between billby billto
    doc.line(570, initial_y, 30, initial_y) //horizontal line 1 billby upper
    doc.autoTable(table.columnsForAmerica, table.RowsForAmericaInvoice(data), options,);
    const Buttom_Hidden_Table_To_Avoid_FooterOverlap = {
        margin: {
            left: 30, right: 30, bottom: 110
        },
    };

    doc.autoTable(Buttom_Hidden_Table_To_Avoid_FooterOverlap);
}




export const pageFooter = (doc, data) => {
    const pageCount = doc.internal.getNumberOfPages()
    doc.setFont('helvetica', 'Normal')
    doc.setFontSize(8)

    if (!data.isMultiPrint) {
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i)
            pageHeder(doc, data)
            pageBorder(doc)
            reportHeder3(doc, data)

            doc.text('Page' + String(pageCount) + ' of ' + String(i), 532, 403,)
            doc.text('Print Date :' + String(currentDate_dmy) + ' Time ' + String(CurrentTime()), 30, 403,)
        }

    } else {
        pageBorder(doc)
        pageHeder(doc, data)
        reportHeder3(doc, data)

    }
}
